/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfo_viewer = {
    readonly showShippingDiscounts: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"useShippingPrice_viewer">;
    readonly " $refType": "PdpSharedShippingInfo_viewer";
};
export type PdpSharedShippingInfo_viewer$data = PdpSharedShippingInfo_viewer;
export type PdpSharedShippingInfo_viewer$key = {
    readonly " $data"?: PdpSharedShippingInfo_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchRegionalInfo"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfo_viewer",
  "selections": [
    {
      "alias": "showShippingDiscounts",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "subsidizedShippingPDP"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"subsidizedShippingPDP\")"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "fetchRegionalInfo",
          "variableName": "fetchRegionalInfo"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userZipCode",
          "variableName": "userZipCode"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useShippingPrice_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '21a5c0fb6279769788f148d15bc678ea';
export default node;
